import enFI from 'antd/locale/en_US';
import fiFI from 'antd/locale/fi_FI';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import I18NextHttpBackend from 'i18next-http-backend';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import { keys } from 'ramda';
import { initReactI18next } from 'react-i18next';
import { debounce } from 'throttle-debounce';

export const TRANSLATION_UPDATE_EVENT = 'translation-update';

const AVAILABLE_LANGUAGE_CODES = {
  EN: 'en',
  FI: 'fi',
};

const AVAILABLE_LANGUAGES = {
  [AVAILABLE_LANGUAGE_CODES.EN]: 'In English',
  [AVAILABLE_LANGUAGE_CODES.FI]: 'Suomeksi (beta)',
};

export const getAntDesignLocaleFromLanguageCode = (language) => {
  switch (language) {
    case AVAILABLE_LANGUAGE_CODES.FI:
      return fiFI;
    default:
      return enFI;
  }
};

i18n
  .use(intervalPlural)
  .use(initReactI18next)
  .use(I18NextHttpBackend)
  .use(LanguageDetector)
  .init({
    backend: {
      loadPath: '/translations/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
    fallbackLng: 'en',
    fallbackNS: 'common',
    interpolation: { escapeValue: false },
    supportedLngs: keys(AVAILABLE_LANGUAGES),
  });

const updateDebounced = debounce(1000, (file) => {
  // Split using both "/" (Mac/Linux) and "\" (Windows)
  const parts = file.split(/[\\/]/);
  if (parts.length < 2) return;

  // Get the language and namespace from the path
  const [lng, ns] = parts.slice(-2);

  i18n.reloadResources(lng, ns.replace('.json', '')).then(() => {
    // Force a re-render by emitting the languageChanged event
    i18n.emit('languageChanged', i18n.language);
    // eslint-disable-next-line no-console
    console.log('Translations updated.');
  });
});

// Enable Hot Module Replacement (HMR) for translations
if (import.meta.hot) {
  import.meta.hot.on(TRANSLATION_UPDATE_EVENT, async (file) => {
    updateDebounced(file);
  });
}

export default i18n;
